export default "__VITE_ASSET__C9wD2w5D__"